
define("rv!templates/booking/destinations",[],function(){return { v:3,
  t:[ { t:7,
      e:"h1",
      f:[ "What's Your Destination?" ] },
    " ",
    { t:7,
      e:"link",
      a:{ rel:"stylesheet",
        type:"text/css",
        href:"/fe/css/responsive.css?v=1006" } },
    " ",
    { t:7,
      e:"div",
      a:{ "class":"row" },
      f:[ { t:4,
          f:[ { t:7,
              e:"div",
              a:{ style:"margin-left: 20px;" },
              f:[ { t:7,
                  e:"div",
                  a:{ style:"float: left;" },
                  f:[ { t:7,
                      e:"h6",
                      a:{ style:"text-transform: none; width: 700px; margin-bottom: 10px;" },
                      f:[ { t:4,
                          f:[ { t:4,
                              f:[ { t:7,
                                  e:"a",
                                  a:{ href:[ "/callcenter/editDestination.aspx?id=",
                                      { t:2,
                                        r:"Id" } ] },
                                  f:[ "Edit Destination In Admin Portal" ] } ],
                              n:53,
                              r:"destinations.sortedDestinations.0" } ],
                          n:50,
                          x:{ r:[ "destinations.sortedDestinations.length" ],
                            s:"_0===1" } },
                        { t:4,
                          n:51,
                          f:[ { t:7,
                              e:"a",
                              a:{ href:"/callcenter/FindDestination.aspx" },
                              f:[ "Edit Destinations In Admin Portal" ] } ],
                          x:{ r:[ "destinations.sortedDestinations.length" ],
                            s:"_0===1" } } ] } ] },
                " ",
                { t:7,
                  e:"br",
                  a:{ "class":"clear" } } ] } ],
          n:50,
          x:{ r:[ "inRole" ],
            s:"_0(\"Admin\",\"CallCenter\")" } },
        " ",
        { t:7,
          e:"div",
          a:{ id:"destination-results",
            style:"min-height: 700px;" },
          f:[ " ",
            { t:4,
              f:[ { t:7,
                  e:"div",
                  a:{ id:"popularDestinationsHeader" },
                  f:[ { t:7,
                      e:"h2",
                      a:{ "class":"dest-level" },
                      f:[ "Popular Destinations" ] } ] },
                " ",
                { t:7,
                  e:"div",
                  a:{ id:"popularDestinationsContainer" },
                  f:[ { t:7,
                      e:"div",
                      a:{ id:"popularDestinations" },
                      f:[ { t:4,
                          f:[ { t:8,
                              r:"destination" } ],
                          n:52,
                          r:"destinations.popularDestinations" } ] } ] } ],
              n:50,
              x:{ r:[ "destinations.popularDestinations.length" ],
                s:"_0>0" } },
            " ",
            { t:4,
              f:[ { t:4,
                  f:[ " ",
                    { t:4,
                      f:[ { t:7,
                          e:"div",
                          a:{ id:"dest-container",
                            style:"margin-top: 20px;" },
                          f:[ { t:7,
                              e:"div",
                              a:{ id:[ { t:4,
                                    f:[ "noImg" ],
                                    n:50,
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } },
                                  { t:4,
                                    n:51,
                                    f:[ "hasImg" ],
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } } ],
                                "class":[ "dest-span",
                                  { t:4,
                                    f:[ "4" ],
                                    n:50,
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } },
                                  { t:4,
                                    n:51,
                                    f:[ "8" ],
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } } ] },
                              f:[ " ",
                                { t:7,
                                  e:"img",
                                  a:{ id:"r-bannerImage",
                                    src:[ { t:2,
                                        r:"imageLarge" } ],
                                    alt:[ { t:2,
                                        r:"RegionName" } ],
                                    style:"border-radius: 10px;" } } ] },
                            " ",
                            { t:7,
                              e:"div",
                              a:{ id:[ { t:4,
                                    f:[ "noImg-text" ],
                                    n:50,
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } },
                                  { t:4,
                                    n:51,
                                    f:[ "hasImg-text" ],
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } } ],
                                "class":[ "dest-span",
                                  { t:4,
                                    f:[ "8" ],
                                    n:50,
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } },
                                  { t:4,
                                    n:51,
                                    f:[ "4" ],
                                    x:{ r:[ "isNullOrWhiteSpace",
                                        "LargeImage" ],
                                      s:"_0(_1)" } } ] },
                              f:[ " ",
                                { t:7,
                                  e:"h3",
                                  f:[ { t:2,
                                      r:"RegionName" } ] },
                                " ",
                                { t:7,
                                  e:"p",
                                  a:{ style:"margin-top: 0px !important" },
                                  f:[ { t:2,
                                      r:"Description" } ] },
                                " ",
                                { t:4,
                                  f:[ { t:7,
                                      e:"a",
                                      a:{ "class":"fh-button-green fh-icon--check ",
                                        href:[ "./about/fareharbor/?dest=",
                                          { t:2,
                                            r:"Latitude" },
                                          ",",
                                          { t:2,
                                            r:"Longitude" } ],
                                        target:"_blank",
                                        style:"margin-top: 10px;" },
                                      f:[ "Local Activities (",
                                        { t:2,
                                          r:"LocalActivities" },
                                        ")" ] } ],
                                  n:50,
                                  x:{ r:[ "LocalActivities" ],
                                    s:"_0>0" } },
                                " ",
                                { t:7,
                                  e:"br",
                                  a:{ "class":"clear" } },
                                " ",
                                { t:7,
                                  e:"button",
                                  a:{ type:"button",
                                    "class":"btn btn-primary btn-large",
                                    style:"margin-top: 10px;" },
                                  v:{ click:"onSearch" },
                                  f:[ "Find a Hotel" ] },
                                " ",
                                { t:7,
                                  e:"button",
                                  a:{ type:"button",
                                    "class":"btn btn-large",
                                    style:"margin-top: 10px;" },
                                  v:{ click:"onResetSearch" },
                                  f:[ "All Destinations" ] } ] } ] } ],
                      n:53,
                      r:"destinations.sortedDestinations.0" },
                    " ",
                    { t:4,
                      f:[ { t:7,
                          e:"br",
                          a:{ "class":"clear" } },
                        " ",
                        { t:7,
                          e:"div",
                          a:{ "class":"nearbyDestinations-header",
                            style:"display: flex;" },
                          f:[ { t:7,
                              e:"div",
                              a:{ id:"nearbyDestinationsHeader" },
                              f:[ { t:7,
                                  e:"h2",
                                  a:{ "class":"dest-level" },
                                  f:[ "Nearby Destinations" ] } ] },
                            " ",
                            { t:7,
                              e:"select",
                              a:{ name:"nearby-destinations",
                                "class":"destination-search-mileage",
                                id:"nearby-mileageSelector",
                                value:[ { t:2,
                                    r:"nearbyMileage" } ],
                                style:"margin: 0 5px; width: 100px;" },
                              v:{ change:"getNearbyDestinations" },
                              f:[ { t:7,
                                  e:"option",
                                  a:{ value:"50" },
                                  f:[ "50 miles" ] },
                                " ",
                                { t:7,
                                  e:"option",
                                  a:{ value:"100" },
                                  f:[ "100 miles" ] },
                                " ",
                                { t:7,
                                  e:"option",
                                  a:{ value:"150" },
                                  f:[ "150 miles" ] },
                                " ",
                                { t:7,
                                  e:"option",
                                  a:{ value:"250" },
                                  f:[ "250 miles" ] },
                                " ",
                                { t:7,
                                  e:"option",
                                  a:{ value:"500" },
                                  f:[ "500 miles" ] } ] } ] },
                        " ",
                        { t:4,
                          f:[ { t:7,
                              e:"img",
                              a:{ "class":"nearbyDestinationsSpinner",
                                src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif",
                                alt:"Loading..." } } ],
                          n:50,
                          r:"loadingNearbyDestinations" },
                        { t:4,
                          n:51,
                          f:[ { t:4,
                              f:[ " ",
                                { t:7,
                                  e:"div",
                                  a:{ id:"nearbyDestinationsContainer" },
                                  f:[ { t:7,
                                      e:"div",
                                      a:{ id:"nearbyDestinations" },
                                      f:[ { t:4,
                                          f:[ { t:8,
                                              r:"destination" } ],
                                          n:52,
                                          r:"destinations.nearbyDestinations" } ] } ] } ],
                              n:50,
                              x:{ r:[ "destinations.nearbyDestinations.length" ],
                                s:"_0>0" } },
                            { t:4,
                              n:51,
                              f:[ { t:7,
                                  e:"p",
                                  a:{ id:"noDestinations",
                                    style:"margin-left: 20px;" },
                                  f:[ "There are no nearby destinations within the current search area. Try again by expanding the search area." ] } ],
                              x:{ r:[ "destinations.nearbyDestinations.length" ],
                                s:"_0>0" } } ],
                          r:"loadingNearbyDestinations" } ],
                      n:50,
                      x:{ r:[ "destinations.nearbyDestinations" ],
                        s:"_0!=null" } },
                    { t:4,
                      n:51,
                      f:[ { t:7,
                          e:"img",
                          a:{ "class":"nearbyDestinationsSpinner",
                            src:"https://adestinn2blob.blob.core.windows.net/images/loading12102015-2.gif",
                            alt:"Loading..." } } ],
                      x:{ r:[ "destinations.nearbyDestinations" ],
                        s:"_0!=null" } } ],
                  n:50,
                  x:{ r:[ "destinations.sortedDestinations.length" ],
                    s:"_0===1" } },
                { t:4,
                  n:51,
                  f:[ " ",
                    { t:7,
                      e:"div",
                      a:{ "class":"sortDestinations" },
                      f:[ { t:7,
                          e:"br",
                          a:{ "class":"clear" } },
                        " ",
                        { t:7,
                          e:"h3",
                          a:{ style:"margin-bottom: 0;" },
                          f:[ "Sort By:" ] },
                        " ",
                        { t:7,
                          e:"select",
                          a:{ name:"destination-sort",
                            "class":"temp",
                            id:"sortSelector",
                            value:[ { t:2,
                                r:"destinationSort" } ],
                            style:"width: 175px;" },
                          v:{ change:"onSortDestinations" },
                          f:[ { t:7,
                              e:"option",
                              a:{ value:"asc" },
                              f:[ "Destination Name (A-Z)" ] },
                            " ",
                            { t:7,
                              e:"option",
                              a:{ value:"desc" },
                              f:[ "Destination Name (Z-A)" ] },
                            " ",
                            { t:7,
                              e:"option",
                              a:{ value:"rand" },
                              f:[ "Random" ] } ] } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"allDestinationsHeader" },
                      f:[ { t:7,
                          e:"h2",
                          a:{ "class":"dest-level" },
                          f:[ "All Destinations" ] } ] },
                    " ",
                    { t:7,
                      e:"div",
                      a:{ id:"allDestinationsContainer" },
                      f:[ { t:7,
                          e:"div",
                          a:{ id:"allDestinations" },
                          f:[ { t:4,
                              f:[ { t:8,
                                  r:"destination" } ],
                              n:52,
                              r:"destinations.sortedDestinations" } ] } ] } ],
                  x:{ r:[ "destinations.sortedDestinations.length" ],
                    s:"_0===1" } },
                " ",
                { t:7,
                  e:"br",
                  a:{ "class":"clear" } } ],
              n:50,
              x:{ r:[ "destinations.sortedDestinations.length" ],
                s:"_0>0" } } ] },
        " ",
        { t:7,
          e:"br",
          a:{ "class":"clear" } } ] },
    " ",
    { t:7,
      e:"div",
      a:{ id:"myBtn",
        style:"position: fixed;width: 50%;bottom: 20px; display: none;" },
      f:[ { t:7,
          e:"input",
          a:{ "class":"btn btn-primary",
            type:"button",
            value:"TOP",
            onclick:"javascript: topFunction();" } } ] },
    " ",
    { t:7,
      e:"script",
      f:[ "    // When the user scrolls down 20px from the top of the document, show the button\r\n    window.onscroll = function () { scrollFunction() };\r\n\r\n    function scrollFunction() {\r\n        if (window.location.href.indexOf(\"/destinations\") > 0)\r\n        {\r\n            if (document.getElementById(\"myBtn\") && document.getElementById(\"myBtn\").style) {\r\n                if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {\r\n                    document.getElementById(\"myBtn\").style.display = \"block\";\r\n                } else {\r\n                    document.getElementById(\"myBtn\").style.display = \"none\";\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // When the user clicks on the button, scroll to the top of the document\r\n    function topFunction() {\r\n        window.scrollTo(0, 0);\r\n    }" ] } ],
  p:{ destination:[ { t:7,
        e:"div",
        a:{ "class":"destination",
          style:"margin: 0 0 10px 0;" },
        f:[ { t:7,
            e:"a",
            a:{ href:[ { t:2,
                  r:"href" } ],
              "class":"previewLightbox" },
            f:[ { t:7,
                e:"img",
                a:{ "class":"destinationImage",
                  "data-original":[ { t:2,
                      r:"image" } ],
                  src:[ { t:2,
                      r:"contentUrl" },
                    "images/placeholder.gif" ],
                  alt:"" } } ] },
          " ",
          { t:4,
            f:[ { t:7,
                e:"div",
                a:{ "class":"destinationTitleBack" } },
              " ",
              { t:7,
                e:"a",
                a:{ href:[ { t:2,
                      r:"href" } ],
                  "class":"previewLightbox" },
                f:[ { t:7,
                    e:"p",
                    a:{ "class":"destinationTitle" },
                    f:[ { t:2,
                        r:"RegionName" } ] } ] } ],
            n:50,
            x:{ r:[ "hideTitle" ],
              s:"!_0" } } ] } ] } };});
